var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg11A(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2420_2892)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1929 0.547089H15.9323H14.5679H-0.0571289V10.2032V11.5677V19.8593V21.2238V29.5154V30.88V40.5361H39.9319L39.9319 27.5782V26.2967V14.7864V13.3389L39.9319 0.547089H30.5573H29.1929ZM38.5673 27.6613V39.1715L30.5574 39.1715V27.6613H38.5673ZM29.1928 30.88V39.1715H15.9324V30.88H29.1928ZM29.1928 10.2032H15.9324V1.91162H29.1928V10.2032ZM15.9324 11.5677V19.8593H29.1928V11.5677H15.9324ZM38.5673 13.3389V1.91162H30.5574V13.3389H38.5673ZM30.5574 14.7864V26.2137H38.5673V14.7864H30.5574ZM1.3074 29.5154H14.5678V21.2238H1.3074V29.5154ZM14.5678 39.1715L1.3074 39.1715V30.88H14.5678V39.1715ZM1.3074 10.2032H14.5678V1.91162H1.3074V10.2032ZM14.5678 19.8593H1.3074V11.5677H14.5678V19.8593ZM15.9324 29.5154H29.1928V21.2238H15.9324V29.5154Z",
    fill: "#041E42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2420_2892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.47934)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg11A);
export default __webpack_public_path__ + "static/media/11a.8fd6353ae17a5bb5f73d47e809f3b311.svg";
export { ForwardRef as ReactComponent };